export const FIELD_LABEL = "si.lead_gen_filters.excludeBySuppressionList.name";
export const DROPDOWN_BUTTON = "si.lead_gen_filters.excludeBySuppressionList.dd_button";
export const DROPDOWN_PLACEHOLDER = "si.common.search";
export const SELECT_ALL_LABEL = "si.lead_gen_filters.excludeBySuppressionList.selected_all_label";